import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
const included = ['El Oráculo de las Preguntas', 'Los 6 Tomos completos', 'Más de 600 preguntas estratégicas', 'Protocolos organizados por etapa de la sesión', 'Acceso inmediato', 'Actualizaciones futuras del material', 'Los 6 Bonos Exclusivos'];
interface PricingSectionProps {
  onCta: () => void;
}
export function PricingSection({
  onCta
}: PricingSectionProps) {
  return <section id="oferta" className="bg-[#faf6fb] px-4 py-14" data-id="element-166" data-mp="1x99ie2zm2x8w">
      <div className="mx-auto max-w-md" data-id="element-167" data-mp="228cnfnfld3gv">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-plum" data-id="element-168" data-mp="2271njyp9ofv1">
          Todo lo que recibirás hoy
        </h2>

        <ul className="mt-6 space-y-2.5 rounded-2xl border border-purple-100 bg-white p-5 shadow-sm" data-id="element-169" data-mp="7tih1zd9dmxl">
          {included.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-170" data-mp="1mhgakmva19b5">
              <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100" data-id="element-171" data-mp="1hpg2u88ytc40">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-600" data-id="element-172" data-mp="1crwnt64g0vb0" />
              </span>
              <span className="text-sm font-medium text-plum/80" data-id="element-173" data-mp="17stkpr80wz5o">{item}</span>
            </li>)}
        </ul>

        {/* value stack */}
        <div className="mt-6 overflow-hidden rounded-2xl border border-purple-100 bg-white shadow-sm" data-id="element-174" data-mp="25dg2xys62ev9">
          <p className="bg-plum px-4 py-3 text-center text-sm font-bold text-white" data-id="element-175" data-mp="20emrebwfwxxq">
            El valor real de todo este sistema
          </p>
          <div className="divide-y divide-purple-50" data-id="element-176" data-mp="1repwhsjgj2u8">
            <div className="flex items-center justify-between px-4 py-3" data-id="element-177" data-mp="1ri3xoxgdx603">
              <span className="text-sm text-plum/70" data-id="element-178" data-mp="k3ircut0671k">El Oráculo (6 Tomos)</span>
              <span className="text-sm font-semibold text-plum/50 line-through" data-id="element-179" data-mp="fzt6afbje7la">$197 USD</span>
            </div>
            <div className="flex items-center justify-between px-4 py-3" data-id="element-180" data-mp="hiazvj66s1me">
              <span className="text-sm text-plum/70" data-id="element-181" data-mp="mftbjhbl8uy3">6 Bonos Exclusivos</span>
              <span className="text-sm font-semibold text-plum/50 line-through" data-id="element-182" data-mp="7k3mfab3w1p5">$162 USD</span>
            </div>
            <div className="flex items-center justify-between bg-rose-50/60 px-4 py-3" data-id="element-183" data-mp="chvnouxn5060">
              <span className="text-sm font-bold text-plum" data-id="element-184" data-mp="3uw4kehpgo0hs">Valor total</span>
              <span className="font-display text-lg font-bold text-plum/60 line-through" data-id="element-185" data-mp="3i07gbp8aez4">
                $359 USD
              </span>
            </div>
          </div>
        </div>

        {/* offer card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-6 rounded-3xl bg-gradient-to-b from-[#4a1d6a] to-[#35114f] p-6 text-center text-white shadow-xl" data-id="element-186" data-mp="3pxbiznng7zxz">
          <span className="inline-block rounded-full bg-pink px-4 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-187" data-mp="3g189txu6j11j">
            Oferta especial de lanzamiento
          </span>
          <p className="mt-4 text-sm text-white/70" data-id="element-188" data-mp="2se3acwie7yv1">Pero hoy no pagarás ese precio. Accede por solo</p>
          <div className="mt-2 flex items-end justify-center gap-2" data-id="element-189" data-mp="369f1ktxcb777">
            <span className="font-display text-6xl font-black text-pink" data-id="element-190" data-mp="31b560i7pe4l2">$12.99</span>
            <span className="mb-2 text-lg font-semibold text-white/80" data-id="element-191" data-mp="3g8xlxbh5wuzs">USD</span>
          </div>
          <p className="mt-1 text-sm font-medium text-white/80" data-id="element-192" data-mp="3b9tdin22b1ai">
            Pago único · Acceso de por vida · Descarga inmediata
          </p>

          <div className="mt-5 flex items-center justify-center gap-2 rounded-xl bg-white/10 px-3 py-2 text-xs font-medium text-white/85" data-id="element-193" data-mp="3p43tofzztn4y">
            <GlobeIcon className="h-4 w-4 flex-shrink-0 text-pink" data-id="element-194" data-mp="2u9mzvsrzwz5" />
            El cambio de moneda es automático según tu país.
          </div>

          <div className="mt-5 rounded-2xl bg-white/95 p-4" data-id="element-195" data-mp="3tz9cv720gnpc">
            <CountdownTimer data-id="element-196" data-mp="hx1biwktdijl" />
          </div>

          <div className="mt-5" data-id="element-197" data-mp="hw9q2ekxl171">
            <CtaButton onClick={onCta} data-id="element-198" data-mp="lz5zpfshtmyu">Quiero el Oráculo de las Preguntas</CtaButton>
          </div>
          <p className="mt-3 text-xs text-white/60" data-id="element-199" data-mp="qpw8l304o7ya">
            Pago único • Acceso inmediato • Garantía de 7 días
          </p>
        </motion.div>

        <div className="mt-6" data-id="element-200" data-mp="vopof22w0b1m">
          <ScarcityBar data-id="element-201" data-mp="3v4vyuhtjnsja" />
        </div>
      </div>
    </section>;
}